export const SET_SERVICE_TO_EDIT = 'NFSE_COMPONENTS/SET_SERVICE_TO_EDIT';
export const SET_MODAL_CANCEL_NFSE_ID = 'NFSE_COMPONENTS/SET_MODAL_CANCEL_NFSE_ID';
export const SET_TOGGLE_MODAL_CANCEL_NFSE = 'NFSE_COMPONENTS/SET_TOGGLE_MODAL_CANCEL_NFSE';
export const SET_TOGGLE_MODAL_EDIT_SERVICE = 'NFSE_COMPONENTS/SET_TOGGLE_MODAL_EDIT_SERVICE';
export const SET_TOGGLE_MODAL_FISCAL_VALIDATION =
  'NFSE_COMPONENTS/SET_TOGGLE_MODAL_FISCAL_VALIDATION';
